import classNames from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';

export interface IPhotoFeatureIconProps {
  icon: React.ReactNode;
  className?: string;
}

export function PhotoFeatureIcon({ icon, className }: IPhotoFeatureIconProps) {
  return <span className={classNames(styles.container, className)}>{icon}</span>;
}
